import React, { useEffect, useState } from "react";
import SeparadorLogin from "../../Genericos/SeparadorLogin/SeparadorLogin";
import LoginIcon from "../../../assets/images/generico/LoginIcon";
import { IonSpinner, getPlatforms } from "@ionic/react";
import { useContext } from "react";
import "./LoginBox.css";
import { PortalContext } from "../../../context/Provider";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import HidePassIcon from "../../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../../assets/images/generico/ShowPassIcon";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { GlobalContext } from "../../../../global/context/Provider";
import { useHistory } from "react-router";
import { Capacitor } from "@capacitor/core";

const LoginBox = ({
  form,
  error,
  onChange,
  onSubmit,
  loginFormValid,
  loading,
  onClickSocialHandler,
  onClickRegister,
  onClickChangePassword,
  responseFacebook,
}) => {
  const { configState } = useContext(GlobalContext);
  const { registroState, modalState } = useContext(PortalContext);
  const [passwordShown, setPasswordShown] = useState(false);
  const [versionApk, setVersionApk] = useState(false);
  const history = useHistory();
  const isMobile =
    Capacitor.platform === "ios" || Capacitor.platform === "android";
  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const onKeyPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      if (loginFormValid) {
        onSubmit(form);
      }
    }
  };

  const onClickSegundoFactor = () => {
    history.push("/segundofactor");
  };

  useEffect(() => {
    if (configState.config.data) {
      setVersionApk(configState.config?.data?.version);
    }
  }, [configState.config.data]);

  return (
    <React.Fragment>
      <div className="ptur-loginBoxImg">
        <img
          style={{ marginBottom: 25, width: 160 }}
          src="../../../../assets/images/empresa/IsoLogo.png"
          alt="logo"
        ></img>
      </div>
      <div className="loginBox">
        <span className="rb32b c-latex10">Hola !</span>
        <div className="ptur-loginDivMarginTop"></div>
        {Array.isArray(form) &&
          form?.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <InputV1
                  inputType={item.inputType}
                  name={item.name}
                  headerStr={item.headerStr}
                  placeholderText={item.placeholderText}
                  linkStr={item.linkStr}
                  errorStr={modalState.modal.show ? "" : item.errorStr}
                  onChange={onChange}
                  onKeyPress={onKeyPress}
                  onClickChangePassword={onClickChangePassword}
                  value={item.value}
                  className={
                    passwordShown && item.name === "password"
                      ? item.className + " inputNumericShow"
                      : item.name === "nro_documento"
                      ? item.className
                      : item.className + " inputNumeric"
                  }
                  maxLength={item.maxLength}
                  error={error}
                  checkError={
                    modalState.modal.show
                      ? ""
                      : registroState.registro.listError[item.name]
                  }
                  isRequired={item.isRequired}
                  inputMode={item.inputMode}
                  pattern={item.pattern}
                  desactivado={modalState.modal.show}
                />
                {item.name === "password" ? (
                  <>
                    {passwordShown === false ? (
                      <>
                        <button
                          className="ptur-loginBox-show-hideBtn"
                          onClick={() => showPassword()}
                        >
                          <HidePassIcon color="var(--color-latex30)" />
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="ptur-loginBox-show-hideBtn"
                          onClick={() => hidePassword()}
                        >
                          <ShowPassIcon color="var(--color-latex30)" />
                        </button>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          })}
        <div className="ptur-loginDivMarginTop">
          <button
            className={`${
              loginFormValid ? "bgc-primary cursor:pointer " : "bgc-disabled"
            } c-white ptur-buttonLogin`}
            disabled={!loginFormValid || loading}
            onClick={onSubmit}
          >
            <LoginIcon />
            <span
              style={{ paddingLeft: 8, verticalAlign: "middle" }}
              className="rb18m"
            >
              {loading ? "Ingresando" : "Ingresar al Portal"}
            </span>
            {loading ? (
              <span className="spinner">
                <IonSpinner name="lines" />
              </span>
            ) : (
              ""
            )}
          </button>
          {isMobile && (
            <div className="segundoFactor-txt-container">
              <span
                onClick={onClickSegundoFactor}
                className="rb14m c-latex30 segundoFactor-txt-underline"
              >
                Consultar segundo factor
              </span>
            </div>
          )}
        </div>
        <div className="ptur-loginBox-versionPortal">
          <span className="c-grey65 rb12m">{versionApk}</span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginBox;
